export const trustStats = [
  { value: '1,000+', label: 'Curated Spreadsheet Links' },
  { value: '50K+', label: 'Monthly Active Users' },
  { value: '99%', label: 'QC Pass Rate' },
  { value: '24/7', label: 'Live Updates' },
];

export const aboutText = 'SugargooSpreadsheet.link is an independent community-driven resource dedicated to helping shoppers discover the best finds across Sugargoo. We curate verified spreadsheet links, share real QC photos, and connect you with trusted sellers. Our mission is to make your Sugargoo shopping experience faster, safer, and more enjoyable. Updated daily for 2026, our directory covers sneakers, clothing, accessories, electronics, and everything in between.';